import { useQuery, useQueryClient } from "@tanstack/react-query";
import WarehouseService from "../services/Warehouses/WarehouseService";
import useDebounced from "./useDebounced";
import { useEffect, useState } from "react";

const useWarehouse = (searchQuery = null) => {
  const debouncedQuery = useDebounced(searchQuery);
  const queryClient = useQueryClient();
  const [filteredData, setFilteredData] = useState([]);

  useEffect(() => {
    if (debouncedQuery === null)
      return;

    const data = queryClient.getQueryData(["warehouses"]);
    if (data) {
      const filtered = data?.filter(w => (
        w.name.toLowerCase().includes(debouncedQuery.toLowerCase()) ||
        w.shortCode.toLowerCase().includes(debouncedQuery.toLowerCase())
      ));

      setFilteredData(filtered);
    }
  }, [debouncedQuery, queryClient]);

  const query = useQuery({
    queryKey: ["warehouses"],
    queryFn: async () => await WarehouseService.getAllWarehouses(),
    enabled: searchQuery === null,
  });

  return { ...query, data: filteredData?.length > 0 ? filteredData : query.data };
};

export default useWarehouse;